module.exports = __webpack_public_path__ + "img/truck-icon.f0b7abf0.svg";